"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const moment_1 = __importDefault(require("moment"));
const styles_1 = require("./styles");
const MAX_MONTH = 12;
const InputDate = ({ value, onChange, minYear, maxYear, inputRef }) => {
    const date = (0, moment_1.default)(value, ["DDMMyyyy"]);
    const [day, setDay] = (0, react_1.useState)(date.format("DD"));
    const [year, setYear] = (0, react_1.useState)(date.format("yyyy"));
    const [errorYear, setErrorYear] = (0, react_1.useState)();
    const [month, setMonth] = (0, react_1.useState)(date.format("MM"));
    const [maxDay, setMaxDay] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        // months in JS from 0 - 11
        const fixMonth = Number(month) - 1;
        if (fixMonth >= 0 && year.length === 4)
            onChange &&
                onChange({
                    target: { value: new Date(Number(year), fixMonth, Number(day)) }
                });
        if (year && month) {
            setMaxDay(new Date(Number(year), Number(month), 0).getDate());
        }
    }, [year, month, day, onChange]);
    const onChangeDay = (e) => {
        if (maxDay) {
            Number(e.target.value) <= maxDay && setDay(e.target.value);
        }
    };
    const onChangeMonth = (e) => {
        Number(e.target.value) <= MAX_MONTH && setMonth(e.target.value);
    };
    const onChangeYear = (e) => {
        let errorYear;
        if (Number(e.target.value) < minYear)
            errorYear = "is less than the required year";
        if (Number(e.target.value) > maxYear)
            errorYear = "exceeds the maximum year";
        setErrorYear(errorYear);
        if (e.target.value.length < 4)
            setYear(e.target.value);
        Number(e.target.value) <= maxYear &&
            Number(e.target.value) >= minYear &&
            setYear(e.target.value);
    };
    const selectValues = (e) => e.target.select();
    return (react_1.default.createElement(styles_1.StyleWrapperInputDate, { ref: inputRef },
        react_1.default.createElement(styles_1.StyleInputDate, { value: day, type: "number", onChange: onChangeDay, onFocus: selectValues, placeholder: "DD", min: "0", max: maxDay }),
        react_1.default.createElement("span", null, "/"),
        react_1.default.createElement(styles_1.StyleInputDate, { value: month, type: "number", onChange: onChangeMonth, onFocus: selectValues, placeholder: "MM", min: "0", max: MAX_MONTH }),
        react_1.default.createElement("span", null, "/"),
        react_1.default.createElement(styles_1.StyleInputDateYear, { value: year, type: "number", onChange: onChangeYear, onFocus: selectValues, placeholder: "YYYY", min: minYear, max: maxYear }),
        errorYear && react_1.default.createElement(styles_1.StyledErrorYear, null, errorYear)));
};
exports.default = InputDate;
